import cx from 'classnames';
import * as React from 'react';

import {
  Accordion,
  AccordionItem,
  AccordionItemBody,
  AccordionItemTitle,
} from 'components/Accordion';
import Button from 'components/Button';
import Buttons, { ButtonsAlign } from 'components/Buttons';
import Heading from 'components/Heading';
import Icon from 'components/Icon';
import Row from 'components/Row';
import './Profile.scss';

export type ProfileSection = {
  children?: any;
  collapsible?: boolean;
  defaultOpen?: boolean;
  count?: number;
  disabled?: boolean;
  title?: string;
};

type Props = {
  actions?: React.ReactElement;
  className?: string;
  header: React.ReactElement;
  sections: Array<ProfileSection>;
  onChange?: (keys: string[]) => void;
  onBackClicked?: () => void;
  onClose: () => void;
  noteField?: React.ReactElement;
  loadingIndicator?: React.ReactElement;
  errorBanner?: React.ReactElement;
};

export default class Profile extends React.Component<Props> {
  render() {
    const {
      actions,
      className,
      header,
      loadingIndicator,
      errorBanner,
      sections,
      onChange,
      onClose,
      noteField,
      onBackClicked,
    } = this.props;

    const align = 'right' as ButtonsAlign;
    const buttonProps = onBackClicked ? { split: true } : { align };

    return (
      <div className={cx('Profile', className)}>
        <Row size="xsmall">
          <Buttons {...buttonProps}>
            {onBackClicked && (
              <Button level="icon" aria-label="Back" onClick={onBackClicked}>
                <Icon name="arrow-left" />
              </Button>
            )}
            <Button level="icon" aria-label="Close profile" onClick={onClose}>
              <Icon name="x" />
            </Button>
          </Buttons>
        </Row>
        <Row size="medium">{header}</Row>
        <Row size="small">{noteField}</Row>
        {actions && <Row size="xsmall">{actions}</Row>}
        {loadingIndicator}
        {errorBanner}
        <Accordion onChange={onChange}>
          {sections.map(item => {
            const { children, collapsible, count, title, defaultOpen } = item;

            const emptyWithAction = children && (count === 0 || !count);
            const fauxAccordionItem = collapsible === false || emptyWithAction || !children;

            return (
              <AccordionItem key={title} uuid={title} expanded={defaultOpen}>
                <AccordionItemTitle
                  faux={fauxAccordionItem}
                  className="Profile-accordion-item-title">
                  <Heading level="3" flush>
                    {title}
                    {count !== undefined && ` (${count})`}
                  </Heading>
                </AccordionItemTitle>
                <AccordionItemBody faux={fauxAccordionItem}>{children}</AccordionItemBody>
              </AccordionItem>
            );
          })}
        </Accordion>
      </div>
    );
  }
}
